import { render } from "./Notifications.vue?vue&type=template&id=bf4edc32&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=bf4edc32&lang=scss"
import "./Notifications.vue?vue&type=style&index=1&id=bf4edc32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4edc32"]])

export default __exports__